import React from "react";

function FilterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      fill="none"
      viewBox="0 0 16 10"
    >
      <path fill="#fff" d="M3 4h10v2H3V4zM0 0h16v2H0V0zm6 8h4v2H6V8z"></path>
    </svg>
  );
}

export default FilterIcon;
